import { render, staticRenderFns } from "./ChildrenFamily.vue?vue&type=template&id=0c621d50&scoped=true&"
import script from "./ChildrenFamily.vue?vue&type=script&lang=js&"
export * from "./ChildrenFamily.vue?vue&type=script&lang=js&"
import style0 from "./ChildrenFamily.vue?vue&type=style&index=0&id=0c621d50&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c621d50",
  null
  
)

export default component.exports